"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (shop, country) {
  var countryCode = shop.countryCode;

  var shopName = void 0,
      shopStreet = void 0,
      shopStreet1 = void 0,
      shopZipCode = void 0,
      shopCity = void 0;
  if (countryCode === country) {
    shopName = shop.localeName;
    shopStreet = shop.localeStreet1;
    shopStreet1 = shop.localeStreet2;
    shopZipCode = shop.localeZipCode;
    shopCity = shop.localeCity;
  }

  return {
    shopName: shopName || shop.defaultName,
    shopStreet: shopStreet || shop.defaultStreet1,
    shopStreet1: shopStreet1 || shop.defaultStreet2,
    shopZipCode: shopZipCode || shop.defaultZipCode,
    shopCity: shopCity || shop.defaultCity,
    shopState: shop.state,
    countryCode: countryCode
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/shared/getShopData.js
// module id = 171
// module chunks = 0